import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-stationery-list',
  templateUrl: './stationery-list.component.html'
})
export class StationeryListComponent implements OnInit {

  @Input('stationery') stationery!: any;
  @Output('triggerAction') triggerAction = new EventEmitter();
  @Output('removeStationery') remove: EventEmitter<string> = new EventEmitter<string>();
  @Output('papertypeChangeOrder') papertypeChangeOrder: EventEmitter<CdkDragDrop<string[]>> = new EventEmitter<CdkDragDrop<string[]>>();
  
  previewBackground!: SafeUrl | null;
  previewId!: string;
  orderPapertypes: any = [];
  newOrderPapertypes: any = [];

  constructor() {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  drop(event: CdkDragDrop<string[]>){
    this.papertypeChangeOrder.emit(event);
  }
  
  showPreview(background: any) {
    if (background !== null) {
      this.previewBackground = background.thumbnail;
      this.previewId = background.id;
    } else {
      this.previewBackground = null;
      this.previewId = "00000000-0000-0000-0000-000000000000";
    }
    this.TriggerAction(this.previewBackground);
  }

  TriggerAction(event:any){
    this.triggerAction.emit(event);
  }

  removeStationery(event:any) {
    this.remove.emit(event);
  }
}
